var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "workflow-grid-wrapper", class: { loading: _vm.loading } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      !_vm.loading
        ? _c("no-results", {
            attrs: { results: _vm.workflows, message: _vm.noResultsText }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.anyWorkflows
        ? _c("RecycleScroller", {
            ref: "workflowGrid",
            staticClass: "workflow-grid results",
            attrs: {
              "key-field": "uniqueId",
              items: _vm.workflows,
              "item-size": 56,
              "emit-update": "",
              "data-cy": "workflow-list"
            },
            on: { update: _vm.onScroll },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    var index = ref.index
                    return [
                      _c(
                        "div",
                        { staticClass: "row", class: { odd: index % 2 === 1 } },
                        [
                          _c("div", { staticClass: "col col-id" }, [
                            _vm._v(_vm._s(item.workflowId))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col col-link" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "workflow/summary",
                                      params: {
                                        clusterName: item.clusterName,
                                        domain: item.domainName,
                                        runId: item.runId,
                                        workflowId: item.workflowId
                                      }
                                    },
                                    "data-cy": "workflow-link"
                                  }
                                },
                                [_vm._v(_vm._s(item.runId) + "\n        ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col col-name" }, [
                            _vm._v(_vm._s(item.workflowName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col col-status",
                              class: item.status
                            },
                            [_vm._v(_vm._s(item.status))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col col-start" }, [
                            _vm._v(_vm._s(item.startTime))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col col-end" }, [
                            _vm._v(_vm._s(item.endTime))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              431814695
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row-header" }, [
      _c("div", { staticClass: "col col-id" }, [_vm._v("Workflow ID")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-link" }, [_vm._v("Run ID")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-name" }, [_vm._v("Name")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-status" }, [_vm._v("Status")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-start" }, [_vm._v("Start Time")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-end" }, [_vm._v("End Time")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a332fafe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a332fafe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/workflow-grid.vue
// module id = 1368
// module chunks = 0